<template>
    <div class="flex-shrink-0 p-3 bg-white" >
        <!-- <a href="/" class="d-flex align-items-center pb-3 mb-3 link-dark text-decoration-none border-bottom">
      <svg class="bi me-2" width="30" height="24"><use xlink:href="#bootstrap"/></svg>
      <span class="fs-5 fw-semibold">Collapsible</span>
    </a> -->
        <ul class="list-unstyled ps-0">
            <li class="mb-1" v-if="hasPermission('Dashboard')">
                <button class="btn btn-toggle-sidebar align-items-center rounded collapsed" data-bs-toggle="collapse"
                :class="{ active: isActive === 'Dashboard' }"
                 @click="setActive('Dashboard')"
                    data-bs-target="#home-collapse"  :aria-expanded="isActive === 'Dashboard' ? 'true' : 'false'">
                    Dashboard
                </button>
                <div class="collapse" :class="{ show: isActive === 'Dashboard' }" id="home-collapse">
                    <ul class="btn-toggle-sidebar-nav list-unstyled fw-normal pb-1 small">
                        <li><router-link :class="{ active_route_link: $route.path === '/dashboard/sensor/overview' }" to="/dashboard/sensor/overview">IoT Insights</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/dashboard/alarm/process' }" to="/dashboard/alarm/process">Alarms</router-link></li>
                        <li><router-link  :class="{ active_route_link: $route.path === '/dashboard/reports' }" to="/dashboard/reports">Reports</router-link></li>
                        <li><router-link  :class="{ active_route_link: $route.path === '/dashboard/lake/house' }" to="/dashboard/lake/house">Lake House</router-link></li>
                        <!-- <li><router-link to="/dashboard/temp/lake/house">Temp Lake House</router-link></li> -->
                    </ul>
                </div>
            </li>
            <li class="mb-1" v-if="hasPermission('Asset')" >
                <button class="btn btn-toggle-sidebar align-items-center rounded collapsed" data-bs-toggle="collapse"
                  :class="{ active: isActive === 'Asset' }"
                    @click="setActive('Asset')"
                    data-bs-target="#dashboard-collapse" :aria-expanded="isActive === 'Asset' ? 'true' : 'false'">
                    IoT Assets
                </button>
                <div class="collapse" :class="{ show: isActive === 'Asset' }" id="dashboard-collapse">
                    <ul class="btn-toggle-sidebar-nav list-unstyled fw-normal pb-1 small">
                        <li><router-link :class="{ active_route_link: $route.path === '/iotassets/assettype' }" to="/iotassets/assettype">Asset Type</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/iotassets/asset' }" to="/iotassets/asset">Asset</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/iotassets/assetlist' }" to="/iotassets/assetlist">Asset List</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/iotassets/networktype' }" to="/iotassets/networktype">Network Type</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/iotassets/network' }" to="/iotassets/network">Network</router-link></li>
                    </ul>
                </div>
            </li>
            <li class="mb-1" v-if="hasPermission('Hub And Sensors')">
                <button class="btn btn-toggle-sidebar align-items-center rounded collapsed" data-bs-toggle="collapse"
                :class="{ active: isActive === 'Hub And Sensors' }"   
                 @click="setActive('Hub And Sensors')"
                data-bs-target="#orders-collapse" :aria-expanded="isActive === 'Hub And Sensors' ? 'true' : 'false'">
                    Hub & Sensors
                </button>
                <div class="collapse" :class="{ show: isActive === 'Hub And Sensors' }" id="orders-collapse">
                    <ul class="btn-toggle-sidebar-nav list-unstyled fw-normal pb-1 small">
                        <li><router-link :class="{ active_route_link: $route.path === '/hubsensors/iothub' }" to="/hubsensors/iothub">IoT Hub</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/hubsensors/os' }" to="/hubsensors/os">OS</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/hubsensors/componenttype' }" to="/hubsensors/componenttype">Component Type</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/hubsensors/component' }" to="/hubsensors/component">Component</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/hubsensors/devicetype' }" to="/hubsensors/devicetype">Device Type</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/hubsensors/device' }" to="/hubsensors/device">Device</router-link></li>
                    </ul>
                </div>
            </li>
           
            <li class="mb-1" v-if="hasPermission('IoT Sensors')">
                <button class="btn btn-toggle-sidebar align-items-center rounded collapsed" data-bs-toggle="collapse"
                :class="{ active: isActive === 'IoT Sensors' }"
                @click="setActive('IoT Sensors')"   
                data-bs-target="#sensors-collapse" :aria-expanded="isActive === 'IoT Sensors' ? 'true' : 'false'">
                    IoT Sensors
                </button>
                <div class="collapse" :class="{ show: isActive === 'IoT Sensors' }" id="sensors-collapse">
                    <ul class="btn-toggle-sidebar-nav list-unstyled fw-normal pb-1 small">
                        <li><router-link :class="{ active_route_link: $route.path === '/iotsensors/sensortype' }" to="/iotsensors/sensortype">Sensor Type</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/iotsensors/sensor' }" to="/iotsensors/sensor">Sensor</router-link></li>
                        <!-- <li><router-link to="">Sensor Rule</router-link></li> -->
                    </ul>
                </div>
            </li>
            <li class="mb-1" v-if="hasPermission('User Mgmt.')">
                <button class="btn btn-toggle-sidebar align-items-center rounded collapsed" data-bs-toggle="collapse"
                :class="{ active: isActive === 'User Mgmt.' }"
                @click="setActive('User Mgmt.')"  
                data-bs-target="#user-collapse" :aria-expanded="isActive === 'User Mgmt.' ? 'true' : 'false'">
                   User Management
                </button>
                <div class="collapse"  :class="{ show: isActive === 'User Mgmt.' }" id="user-collapse">
                    <ul class="btn-toggle-sidebar-nav list-unstyled fw-normal pb-1 small">
                        <li><router-link :class="{ active_route_link: $route.path === '/usermanagement/roletype' }" to="/usermanagement/roletype">Role Type</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/usermanagement/role' }" to="/usermanagement/role">Role</router-link></li>
                        <!-- <li><router-link :class="{ active_route_link: $route.path === '/usermanagement/' }" to="/usermanagement/userlist">User List</router-link></li> -->
                        <li><router-link :class="{ active_route_link: $route.path === '/usermanagement/usertype' }" to="/usermanagement/usertype">User Type</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/usermanagement/user' }" to="/usermanagement/user">User</router-link></li>
                    </ul>
                </div>
            </li>
            <li class="mb-1" v-if="hasPermission('Remote Ops')">
                <button class="btn btn-toggle-sidebar align-items-center rounded collapsed" data-bs-toggle="collapse"
                    :class="{ active: isActive === 'Remote Ops' }"
                    @click="setActive('Remote Ops')"
                data-bs-target="#remote-collapse" :aria-expanded="isActive === 'Remote Ops' ? 'true' : 'false'">
                   Remote Ops
                </button>
                <div class="collapse" :class="{ show: isActive === 'Remote Ops' }"  id="remote-collapse">
                    <ul class="btn-toggle-sidebar-nav list-unstyled fw-normal pb-1 small">
                        <li><router-link :class="{ active_route_link: $route.path === '/remoteops/controller' }" to="/remoteops/controller">Controller</router-link></li>
                    </ul>
                </div>
            </li>
            <li class="mb-1" v-if="hasPermission('Archival')">
                <button class="btn btn-toggle-sidebar align-items-center rounded collapsed" data-bs-toggle="collapse"
                    :class="{ active: isActive === 'Archival' }"
                    @click="setActive('Archival')"
                data-bs-target="#archival-collapse" :aria-expanded="isActive === 'Archival' ? 'true' : 'false'">
                   Archival
                </button>
                <div class="collapse" :class="{ show: isActive === 'Archival' }"  id="archival-collapse">
                    <ul class="btn-toggle-sidebar-nav list-unstyled fw-normal pb-1 small">
                        <li><router-link :class="{ active_route_link: $route.path === '/archival/listdata' }" to="/archival/listdata">List Data</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/archival/exportdata' }" to="/archival/exportdata">Export Data</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/archival/devicegraph' }" to="/archival/devicegraph">Device Graph</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/archival/history' }" to="/archival/history">Archival History</router-link></li>
                        <li><router-link :class="{ active_route_link: $route.path === '/archival/trashscan' }" to="/archival/trashscan">Trash Scan</router-link></li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Sidebar',
    data(){
        return {
            isActive: '',
        }
    },
    // computed: {
    //     userPermissions() {
    //         const user = JSON.parse(sessionStorage.getItem('user'));
    //         return user ? user.oanames : [];
    //     }
    // },
    computed: {
    userPermissions() {
        const user = JSON.parse(sessionStorage.getItem('user'));

        // If the user is not found or user.oanames is not available, redirect to login page
        if (!user || !user.oanames) {
             sessionStorage.removeItem('activeSidebar');
            this.$router.push('/login'); // Redirect to the login page
            return []; // Return empty permissions as a fallback
        }

        return user.oanames;
    }
    },
    methods: {
        hasPermission(permission) {
            // Check if 'All' is in the user permissions
            if (this.userPermissions.includes('All')) {
                return true;
            }
            // Otherwise, check if the specific permission is included
            return this.userPermissions.includes(permission);
        },
        setActive(permission) {
            this.isActive = permission; // Set the current active button
            sessionStorage.setItem('activeSidebar', permission);
        },
        
    },
  mounted() {
  // Retrieve and apply the active state from sessionStorage
  const activeSidebar = sessionStorage.getItem('activeSidebar');
  if (activeSidebar) {
    // Ensure Dashboard is expanded when "All" is found in the active section
    if (activeSidebar === "All") {
      this.isActive = "Dashboard";
    } else {
      this.isActive = activeSidebar;
    }
  }
}


}
</script>
<style scoped>
/* Style for the active button */
.btn.active {
    background-color: #1371E7; /* Customize the active button color */
    color: white;
}
.active_route_link{
    color: #1371E7 !important;
}
</style>